import { TableHeaderType } from "~/models/types/TableHeaderType";
import { LABELS } from "~/resources/Labels";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { SortTable } from "~/models/Commons ";

interface Prop {
  headers: TableHeaderType[];
  showActionsHeader: boolean;
  sortConfig: SortTable;
  handleSort: (key: string) => void;
  lastBorder?:string
}

export const SIMPLTableHeader = ({
  headers,
  sortConfig,
  showActionsHeader,
  handleSort,
  lastBorder=""
}: Prop) => {
  const arrowStyle = { opacity: 0.3, transition: "opacity 0.2s ease" };
  const activeArrowStyle = { opacity: 1 };
  const headerClickableStyle = { cursor: "pointer" };

  const handleKeyAction = (event: React.KeyboardEvent, action: () => void) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      action();
    }
  };

  const lastDataColumnIndex = headers.length - 1;

  return (
    <thead className="h-[24px] font-arial font-bold text-[16px] leading-[24px] tracking-normal">
      <tr>
        {showActionsHeader && (
          <th
            key="tblActions"
            className="w-[160px] bg-[#EAEAEA] p-[16px] px-[8px] font-bold text-center border-r border-white select-none"
          >
            {LABELS.Actions}
          </th>
        )}
        {headers.map((header, index) => {
          const isLastDataColumn = index === lastDataColumnIndex;
          const hasBorder = !isLastDataColumn;

          let ariaSortValue: "ascending" | "descending" | "none" = "none";
          if (sortConfig.key === header.key && sortConfig.direction) {
            if (sortConfig.direction === LABELS.ASC) {
              ariaSortValue = "ascending";
            } else {
              ariaSortValue = "descending";
            }
          }

          return (
            <th
              key={header.key}
              style={header.sortable ? headerClickableStyle : {}}
              className={`gap-3 opacity-100 font-bold bg-[#EAEAEA] p-[16px] text-left select-none ${
                hasBorder ? "border-l border-white" : `${lastBorder}`
              }`}
              onClick={() => header.sortable && handleSort(header.key)}
              onKeyDown={(e) =>
                header.sortable &&
                handleKeyAction(e, () => handleSort(header.key))
              }
              role="columnheader"
              aria-sort={ariaSortValue}
              tabIndex={header.sortable ? 0 : -1}
            >
              <div className="flex items-center gap-0">
                {header.label}
                {header.sortable && (
                  <div className="flex items-center gap-0">
                    <ArrowUpwardIcon
                      style={{
                        marginRight: "-5px",
                        fontSize: "22px",
                        lineHeight: 1,
                        ...(sortConfig.key === header.key &&
                        sortConfig.direction === LABELS.ASC
                          ? activeArrowStyle
                          : arrowStyle),
                      }}
                      shapeRendering="crispEdges"
                    />
                    <ArrowDownwardIcon
                      style={{
                        fontSize: "22px",
                        lineHeight: 1,
                        ...(sortConfig.key === header.key &&
                        sortConfig.direction === LABELS.Desc
                          ? activeArrowStyle
                          : arrowStyle),
                      }}
                      shapeRendering="crispEdges"
                    />
                  </div>
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};